import React, { memo, useCallback, useEffect } from 'react';
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';
// import Datetime from 'react-datetime';
import moment from 'moment';
import 'moment-timezone';
import {getDateFormat, getUserMoment} from '../../../../Utils/UserFunctions';
import {isSet} from '../../../../Utils/CommonFunctions';
import {correctSegmentValue, getDefaultValueDateTime, getSegmentPositionsDateTime, isTextDateSegment, shouldPad} from '../../../../Utils/DateUtils'
import MomentUtils from '@date-io/moment';
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
// cyan lightBlue
import blue from "@material-ui/core/colors/blue";


const detectDateFormat = (dateString) => {
  const dateFormats = [
    getDateFormat('DateTime'),
    'YYYY-MM-DD HH:mm:ss.S'
  ];
  const matchedFormat = dateFormats.find(format => moment(dateString, format, true).isValid());
  return matchedFormat || 'Unknown format';
};


const DatePick = (props)=>{
  const  {
    item,
    className,
    validationForms,
    sectionType,
    fieldObj
  } = props;
  const getDateTimeFormat =  getDateFormat('DateTime');//'YYYY-MM-DD HH:mm:ss.S';
  // const putDateTimeFormat = 'YYYY-MM-DD HH:mm:ss.S';
  useEffect(()=>{
      if(!item.overridden && props.layoutForms){
        let defaultValue = null;
        // console.log('item.selectedValue',isSet(item.default_value,null),item.overridden,isSet(item.selectedValue,null));
        if(isSet(item.default_value,null)!==null && !item.overridden && isSet(item.selectedValue,null)===null){
            const splitDefautDate = item.default_value.split(' ');
            // console.log('splitDefautDate',splitDefautDate);
            if(splitDefautDate[0]==='Today'){
              defaultValue = getUserMoment().format(getDateTimeFormat);
            }else{
              defaultValue = getUserMoment().subtract(splitDefautDate[0], splitDefautDate[1]).format(getDateTimeFormat);
            }
        }
        // console.log('defaultValue',defaultValue,item);
        if(defaultValue!==null){
          props.onChangeInputAction(fieldObj,defaultValue,'date');
        }
      }
  },[item.overridden]);
  
  const onChangeDate = useCallback((moment)=>{
    // console.log('sssss');
    if (isSet(moment,null)!==null &&  typeof moment.format === "function" && props.layoutForms) {
        props.onChangeInputAction(fieldObj,moment.format(getDateTimeFormat),
        'date');
      }else if(props.layoutForms || isSet(moment,null)===null){
        // console.log('defff',(isSet(moment,null)===null)?null:moment.format(putDateTimeFormat));
          props.onChangeInputAction(fieldObj,
            (isSet(moment,null)===null)?null:moment.format(getDateTimeFormat),
            'date');
      } 
   })
   const materialTheme = createTheme({
    palette: {primary: blue},
  });

    const attr = formFieldsAttributes(
      {...item,default_value:null,className:className
    },validationForms);

    let readonlyVal = false;
    if(attr.fieldAttributes && attr.fieldAttributes.readOnly) {
      readonlyVal = attr.fieldAttributes.readOnly;
    }

  // console.log('dispValue',attr.value)
  const displayDate =  (isSet(attr.value,null)!==null && isSet(attr.value,null)!=='Invalid date')?moment(attr.value, detectDateFormat(attr.value), true):null
  // console.log('displayDate',displayDate,attr.value);

   const handleKeyDown = (e) => {
        const input = e.target;
        const key = e.key;
        const format = getDateFormat('DateTime');
        // const separator = format.match(/[^A-Za-z0-9]/)?.[0] || '/';
        const segments = getSegmentPositionsDateTime(format);
        // console.log('segments',segments);
        let cursor = input.selectionStart;
        let value = input.value || getDefaultValueDateTime(format);
  
        const isDigit = /^\d$/.test(key);
        const isLetter = /^[a-zA-Z]$/.test(key);
        const isControl = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(key);
        let didPad = false;
        const currentSegment = segments.find(seg => cursor >= seg.start && cursor <= seg.end);
        if (!currentSegment) return;
  
        const segIndex = segments.indexOf(currentSegment);
        const { start: segStart, end: segEnd } = currentSegment;
        const segLength = segEnd - segStart;
        const segVal = value.slice(segStart, segEnd);
        const isTextSegment = isTextDateSegment(currentSegment.part);
  
        if (!isControl && !((isDigit && !isTextSegment) || (isLetter && isTextSegment))) {
          e.preventDefault();
          return;
        }
  
        if (isDigit) {
          e.preventDefault();
  
          let positionInSegment = cursor - segStart;
          let segChars = segVal.split('');
          const isSegmentFullyFilled = !segChars.includes('_') && !segChars.includes(' ');
  
            // 👇 If segment is full, start fresh on first key press
            if (isSegmentFullyFilled && positionInSegment === 0) {
              segChars = Array(segLength).fill('_');
            }
  
          // Shift left and insert new key at cursor
          segChars.splice(positionInSegment, 0, key);
          segChars = segChars.slice(0, segLength); // Ensure segment length
          const rawUpdated = segChars.join('').replace(/_/g, '');
  
          const segmentType = currentSegment.type;
          const digitsOnly = value.replace(/[^\d]/g, '');
  
          // Auto-pad logic
          if (shouldPad(segmentType, rawUpdated, digitsOnly)) {
            segChars = rawUpdated.padStart(segLength, '0').split('');
          }
  
          let updatedSegment = segChars.join('').padEnd(segLength, '_');
          // const digitsOnly = value.replace(/[^\d]/g, '');
  
          if (shouldPad(currentSegment.part, updatedSegment.replace(/_/g, ''), segChars.join(''))) {
            // updatedSegment = updatedSegment.replace(/_/g, '').padStart(segLength, '0');
            const corrected = correctSegmentValue(currentSegment.part, updatedSegment, digitsOnly);
            updatedSegment = corrected.padEnd(segLength, '_');
            didPad = true;
          }
          // console.log('currentSegment',updatedSegment);
          value = value.slice(0, segStart) + updatedSegment + value.slice(segEnd);
          input.value = value;
  
          const newCursor = segStart + positionInSegment + 1;
  
          queueMicrotask(() => { 
            if (didPad && segIndex < segments.length - 1) {
              // Move to next segment if padding was applied
              const next = segments[segIndex + 1];
              input.setSelectionRange(next.start, next.end);
            } else {
              // const newCursor = segStart + positionInSegment + 1;
              if (newCursor < segEnd) {
                input.setSelectionRange(newCursor, newCursor);
              } else if (segIndex < segments.length - 1) {
                const next = segments[segIndex + 1];
                input.setSelectionRange(next.start, next.end);
              } else {
                input.setSelectionRange(segStart, segEnd);
              }
            }
          });
  
          const momentDate = moment(value, format, true);
          // console.log('momentDate',momentDate);
          if (momentDate.isValid()) {
            onChangeDate?.(momentDate);
          }
  
          return;
        }

        if (isLetter && isTextSegment) {
          e.preventDefault();

          const typedChar = (cursor - segStart) === 0 ? key.toUpperCase() : key.toLowerCase();
          let positionInSegment = cursor - segStart;
          let segChars = segVal.split('');
          const isSegmentFullyFilled = !segChars.includes('_') && !segChars.includes(' ');

          if (isSegmentFullyFilled && positionInSegment === 0) {
            segChars = Array(segLength).fill('_');
          }

          segChars.splice(positionInSegment, 0, typedChar);
          segChars = segChars.slice(0, segLength);
          let updatedSegment = segChars.join('').padEnd(segLength, '_');
          didPad = !updatedSegment.includes('_');

          value = value.slice(0, segStart) + updatedSegment + value.slice(segEnd);
          input.value = value;

          const newCursor = segStart + positionInSegment + 1;

          queueMicrotask(() => {
            if (didPad && segIndex < segments.length - 1) {
              const next = segments[segIndex + 1];
              input.setSelectionRange(next.start, next.end);
            } else if (newCursor < segEnd) {
              input.setSelectionRange(newCursor, newCursor);
            } else if (segIndex < segments.length - 1) {
              const next = segments[segIndex + 1];
              input.setSelectionRange(next.start, next.end);
            } else {
              input.setSelectionRange(segStart, segEnd);
            }
          });

          const momentDate = moment(value, format, true);
          if (momentDate.isValid()) {
            onChangeDate?.(momentDate);
          }

          return;
        }
        if (key === 'Backspace') {
          e.preventDefault();
        
          let newValue = value;
          let newCursor = cursor;
        
          const segVal = value.slice(segStart, segEnd);
          const isCleared = /^[_\s]*$/.test(segVal);
        
          if (!isCleared) {
            // Clear only current segment
            const cleared = '_'.repeat(segEnd - segStart);
            newValue = newValue.slice(0, segStart) + cleared + newValue.slice(segEnd);
            newCursor = segStart;
          } else if (segIndex > 0) {
            // If current segment already cleared, move to previous segment
            const prev = segments[segIndex - 1];
            const prevCleared = '_'.repeat(prev.end - prev.start);
            newValue = newValue.slice(0, prev.start) + prevCleared + newValue.slice(prev.end);
            newCursor = prev.start;
          }
        
          input.value = newValue;
        
          queueMicrotask(() => {
            input.setSelectionRange(newCursor, newCursor);
        
            const allCleared = segments.every(seg => /^[_\s]*$/.test(newValue.slice(seg.start, seg.end)));
            if (allCleared) {
              onChangeDate?.(null);
            }
          });
        
          return;
        }
        
        // if (key === 'Backspace') {
        //   let newValue = value;
        //   let newCursor = cursor;
        //   let currentIndex = segIndex;

        //   // Iterate segments backward if already cleared
        //   while (currentIndex >= 0) {
        //     const seg = segments[currentIndex];
        //     const segVal = newValue.slice(seg.start, seg.end);
        //     const isCleared = /^[_\s]*$/.test(segVal);

        //     if (!isCleared) {
        //       const cleared = '_'.repeat(seg.end - seg.start);
        //       newValue = newValue.slice(0, seg.start) + cleared + newValue.slice(seg.end);
        //       newCursor = seg.start;
        //       break;
        //     }
        //     currentIndex--;
        //   }

        //   input.value = newValue;
        //   requestAnimationFrame(() => {
        //     input.setSelectionRange(newCursor, newCursor);

        //     const digitsOnly = newValue.replace(/[^\d]/g, '');
        //     const allCleared = digitsOnly.length === 0;
        //     if (allCleared) {
        //       onChangeDate(null);
        //     }
        //   });
        //   return;
        // }
  
        if (key === 'ArrowRight' && segIndex < segments.length - 1) {
          e.preventDefault();
          const next = segments[segIndex + 1];
          input.setSelectionRange(next.start, next.end);
          return;
        }
  
        if (key === 'ArrowLeft' && segIndex > 0) {
          e.preventDefault();
          const prev = segments[segIndex - 1];
          input.setSelectionRange(prev.start, prev.end);
          return;
        }
      };
      
    // console.log('segments',getDefaultValue(format));
    const handleFocusOrClick = (e) => {
      const format = getDateFormat('DateTime');
      const input = e.target;
      
          if (!input.value) {
            input.value = getDefaultValueDateTime(format);
            try {
              input.setSelectionRange(0, 0);
            } catch (e) {
              // handle error silently
            }
          } else {
            const segments = getSegmentPositionsDateTime(format);
            const cursor = input.selectionStart || 0;
            const seg = segments.find(s => cursor >= s.start && cursor <= s.end) || segments[0];
            try {
              input.setSelectionRange(seg.start, seg.end);
            } catch (e) {
              // handle error silently
            }
          }
    };
  // initialFocusedDate: when empty, open picker on current time in user's timezone
  const initialFocusedDate =
    (isSet(displayDate, null) !== null && isSet(displayDate, null) !== '')
      ? displayDate
      : getUserMoment();

  return (
    <FormBlocks attr={attr} {...props} item={item} sectionType={sectionType}>
      <ThemeProvider theme={materialTheme}>
          <MuiPickersUtilsProvider utils={MomentUtils} >
            <KeyboardDateTimePicker
              fullWidth
              keyboard
              clearable
              ampm={false}
              margin="normal"
              defaultValue={null} 
              value={displayDate}
              initialFocusedDate={initialFocusedDate}
              // disablePast
              onChange={onChangeDate}
              label=""
              // clearable={true}
              InputProps={{
                className:'form-control',
                style: {fontSize: '0.8rem'},
                disableUnderline: true,
                ...attr.fieldAttributes,
                autoComplete:'off',
                placeholder: getDateFormat('DateTime'),
                onFocus:handleFocusOrClick,
                onClick:handleFocusOrClick,
                onKeyDown:(e)=>{handleKeyDown(e)}
              }}
              readOnly={readonlyVal} 
              //  variant={'inline'}       
              // showTodayButton 
              format={getDateFormat('DateTime')}
              autoOk={true}
              className="MuiFormControl-Custom"
              views={['date','hours','minutes','seconds']}
              // emptyLabel="yyyy/mm/dd HH:MM:SS"
              />
            </MuiPickersUtilsProvider>
        </ThemeProvider>
    </FormBlocks>
  )  
}


DatePick.defaultProps = {
className:'form-control'
}


const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.item===nextProps.item && prevProps.validationForms===nextProps.validationForms && prevProps.item.access_mode===nextProps.item.access_mode && prevProps.item.required===nextProps.item.required){
    return true;
  }
}

export default memo(DatePick,isDiffProps);